import React from 'react';
import { TableRow, TableCell } from 'semantic-ui-react';

import { ProductId } from 'services/products/types';
import StatusIcon from 'components/StatusIcon';
import { UPLOAD_FAILED } from 'components/StatusIcon/constants';
import ProductsTableRowNameFieldValue from '../ProductsTableRowNameFieldValue';
import ProductsTableRowTypeFieldValue from '../ProductsTableRowTypeFieldValue';
import ProductsTableRowActions from '../ProductsTableRowActions';

interface Props {
    productId: ProductId;
    index?: number;
    handleRowClick: Function;
    invalid: boolean;
    handleOnDeleteRowClick: (
        event: React.MouseEvent<HTMLButtonElement>
    ) => void;
    handleOnSortingDownClick: (
        event: React.MouseEvent<HTMLButtonElement>
    ) => void;
    handleOnSortingUpClick: (
        event: React.MouseEvent<HTMLButtonElement>
    ) => void;
    displayActions?: boolean;
    displayErrors?: boolean;
}

export default class ProductsTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const {
            productId,
            index,
            handleRowClick,
            invalid,
            handleOnDeleteRowClick,
            handleOnSortingUpClick,
            handleOnSortingDownClick,
            displayActions,
            displayErrors
        } = this.props;

        if (!index) return null;

        return (
            <TableRow onClick={handleRowClick} style={{ cursor: 'pointer' }}>
                <TableCell collapsing>{index}</TableCell>
                <TableCell textAlign="left">
                    {productId && (
                        <React.Fragment>
                            <ProductsTableRowTypeFieldValue
                                productId={productId}
                            />
                            {' - '}
                            <ProductsTableRowNameFieldValue
                                productId={productId}
                            />
                        </React.Fragment>
                    )}
                </TableCell>
                <TableCell collapsing style={{ padding: 0 }}>
                    {displayActions && (
                        <ProductsTableRowActions
                            handleOnSortingDownClick={handleOnSortingDownClick}
                            handleOnSortingUpClick={handleOnSortingUpClick}
                            handleOnDeleteClick={handleOnDeleteRowClick}
                        />
                    )}
                </TableCell>
                {displayErrors && (
                    <TableCell collapsing>
                        {invalid && <StatusIcon status={UPLOAD_FAILED} small />}
                    </TableCell>
                )}
            </TableRow>
        );
    }
}
